import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { string, bool } from "prop-types";
import { InputAdornment, TextField } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import brandTheme from "brandTheme/Theme";

const style = () => ({
  textField: {
    display: "block",
    width: "100%",
    borderColor: brandTheme.black,
    marginBottom:'7%',
    '& .Mui-disabled':{
      color:brandTheme.fieldColor,
    },
    "& .MuiInputBase-input": {
      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
        "-webkit-appearance": "none",
        margin: "0 12px",
    }
    },
    '& .MuiFormLabel-root.Mui-error':{
      color: brandTheme.errorColor,
    },
    "& .MuiInputLabel-outlined": {
      color:brandTheme.black,
      fontSize:'14px',
      "@media (max-width:768px)":{
          fontSize:'13px',
        },
    },
    "& .MuiFormLabel-root.Mui-focused": {
      color:brandTheme.black,
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: brandTheme.black,
      '& :hover':{
        borderColor: brandTheme.black,
      }
    },
    '& .MuiOutlinedInput-notchedOutline':{
      borderColor: brandTheme.black,
    },
  },
});

const CustomeTextField = ({
  label,
  id,
  disabled,
  required,
  error,
  classes,
  onchange,
  search,
  setState,
  value,
  type,
  maxLength,
  setBlur,
  blurLabel,
  setError,
  setCharge,
  index
}) => {
  return (
    <div className={classes.textField}>
      {search ? (
        <TextField
          error={error}
          required={required}
          id={id}
          label={label}
          variant="outlined"
          style={{
            width: "100%",
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment>
                <SearchIcon />
              </InputAdornment>
            ),
            style: { width: "100%" },
          }}
          onChange={onchange}
          size="small"
        />
      ) : (
        <TextField
          error={error}
          size="small"
          required={required}
          id={id}
          label={label}
          variant="outlined"
          value={value}
          disabled={disabled}
          style={{
            width: "100%",
          }}
          type={type}
          onChange={(event) => {
            if(setCharge){
              setCharge(index,type,event.target.value);
            }if(type==='notCapital'){
            setState(event.target.value);}
            else{
              setState(event.target.value)
            }
          }
           
          }
          onBlur={(event) => {
            setBlur && setBlur(event.target.value, blurLabel);
            setError &&  setError(false)
          }
          }
          inputProps={{ maxLength: maxLength }}
        />
      )}
    </div>
  );
};

CustomeTextField.propTypes = {
  label: string.isRequired,
  id: string,
  required: bool,
};
CustomeTextField.defaultProps = {
  label: string.isRequired,
  id: "text-field",
  required: false,
};
export default withStyles(style)(CustomeTextField);